import React, { Component } from 'react'
import "../css/admin/AdminGrupos.css";
import equis from "../assets/eliminar.svg";
import check from "../assets/check.svg";
import ModalAdmin from './adminComponents/ModalAdmin';
import SideBar from './adminComponents/SideBar';
import Modal from './components/Modal';
import HeaderAdmin from './adminComponents/HeaderAdmin';
import NavBarInfo from './adminComponents/NavBarInfo';
import { ComponenteSpinner } from './adminComponents/ComponenteSpinner';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import Cookies from 'js-cookie';
/*import MaterialTable from "material-table";*/
import MaterialTable from "@material-table/core";

import axios from "axios";
import jwt from 'jwt-decode'


export class AdminGrupos extends Component {
    constructor(props){
        super(props);
        this.state={
            arrayGetGrupos:[],
            gruposSelect:[],
            gruposModalDefault:[],
            modalEditar:false,
            modalEliminar:false,
            modalCrear:false,
            modalGrupoCreado:false,
            modalError:false,
            usuarios:[],
            datosUsuario:{
                nombres:"",
                apellidos:"",
                identificacion:"",
                rol:""
            },
            columnas:[
                {
                    title:"#",
                    field:"idsccecuentausuario",
                },
                {
                    title:"Nombres",
                    field:"idsccepersonaNavigation.nombres",
                },
                {
                    title:"Apellidos",
                    field:"idsccepersonaNavigation.apellidos",
                },
                {
                    title:"Grupo",
                    field: "usuarioGrupo",
                    //tScceGrupoUsuarios
                    render: rowData => rowData.tScceGrupoUsuarios.map((g)=>{
                        return (<div key={g.idsccegrupoNavigation.idsccegrupo}>{g.idsccegrupoNavigation.nombre}</div>);
                    }),
                    
                },
                {
                    title:"Correo",
                    field:"alias",
                    render: rowData=> {return(`${rowData.alias}@espol.edu.ec`)},
                    
                }
            ],
            acciones:[
                rowData=> ({
                    icon:'edit',
                    iconProps: { style: {color: "#767E9F" } },
                    onClick: (event, rowData) => this.abrirModalEditarGrupo(rowData)

                }),
            ],
            crearGrupo:{
                nombre:"",
            },
            editarGrupo:{
                id:0,
                nombres:"",
                apellidos:"",
                usuarioGrupo:[],
                gruposSeleccionados:[],
                correo:"",
            },
            loading:true,
            cerrarSesion:false,

        };
        this.abrirModalEditarGrupo=this.abrirModalEditarGrupo.bind(this);
        this.cerrarModalEditarGrupo=this.cerrarModalEditarGrupo.bind(this);
        this.traerDatosGrupo=this.traerDatosGrupo.bind(this);
        this.onChangeMultiSelect=this.onChangeMultiSelect.bind(this);
        this.abrirModalCrearGrupo=this.abrirModalCrearGrupo.bind(this);
        this.cerrarModalCrearGrupo=this.cerrarModalCrearGrupo.bind(this);
        
        this.abrirModalInfoGrupoCreado=this.abrirModalInfoGrupoCreado.bind(this);
        this.cerrarModalInfoGrupoCreado=this.cerrarModalInfoGrupoCreado.bind(this);

        this.abrirModalInfoGrupoCreado=this.abrirModalInfoGrupoCreado.bind(this);
        this.cerrarModalInfoGrupoEditado=this.cerrarModalInfoGrupoEditado.bind(this);

        this.abrirModalError=this.abrirModalError.bind(this);
        this.cerrarModalError=this.cerrarModalError.bind(this);

        this.cerrarSesion=this.cerrarSesion.bind(this);

    }

    abrirModalInfoGrupoCreado(){
        this.setState({modalGrupoCreado:true});
    }

    cerrarModalInfoGrupoCreado(){
        this.setState({modalGrupoCreado:false})
    }

    abrirModalInfoGrupoEditado(){
        this.setState({modalGrupoEditado:true});
    }

    cerrarModalInfoGrupoEditado(){
        this.setState({modalGrupoEditado:false})
    }

    abrirModalError(){
        this.setState({modalError:true});
    }

    cerrarModalError(){
        this.setState({modalError:false})
    }


    /*EDITAR GRUPO */
    abrirModalEditarGrupo(rowData){
        this.setState({modalEditar:true});
        this.traerDatosGrupo(rowData)
    }

    cerrarModalEditarGrupo(){
        this.setState({modalEditar:false});
        this.setState({gruposModalDefault:[]});
        //console.log("cerrar modal grupo "+this.state.modalEditar);
    }

    traerDatosGrupo = async (rowData) => {
        //console.log(rowData);
        await rowData.tScceGrupoUsuarios.forEach((g)=>{
            this.state.gruposModalDefault.push({
                value: g.idsccegrupoNavigation.idsccegrupo,
                label: g.idsccegrupoNavigation.nombre
            })
        })
        this.setState({
            editarGrupo:{
                ...this.state.editarGrupo,
                id: rowData.idsccecuentausuario,
                nombres: rowData.idsccepersonaNavigation.nombres,
                apellidos: rowData.idsccepersonaNavigation.apellidos,
                usuarioGrupo:rowData.usuarioGrupo,
                correo:rowData.username
            }
        })

        //console.log("traer datos");
        //console.log(this.state.editarGrupo);
    }
    
    
    onChangeMultiSelect=async(e)=>{
        const gruposSeleccionados=[];
        await e.forEach((g)=>{
            gruposSeleccionados.push({
                id:g.value,
                nombre:g.label
            })
        })
        this.setState({
            editarGrupo:{
                ...this.state.editarGrupo,
                gruposSeleccionados:gruposSeleccionados
            }
        })
       // console.log("change multiselect");
       // console.log(this.state.editarGrupo);
        
    }

    getGrupos=async()=>{
        //cargar los grupos a la lista arrayGetGrupos hacer un for y setear el estado
        //se deberia hacer dentro del dismount 
        await axios.get(`${process.env.REACT_APP_API}api/Grupo`)
        
        .then(response => {
            //console.log(response.data);
            this.setState({arrayGetGrupos:response.data});
        })
        this.state.arrayGetGrupos.forEach((grupos)=>{
            this.state.gruposSelect.push({
                value:grupos.idsccegrupo,
                label:grupos.nombre
            })
        })
        //console.log("get grupos");
    }

    getUsuariosPorGrupo = async () => {
        await axios.get(`${process.env.REACT_APP_API}api/CuentaUsuario`)
        .then(response=>{
            this.setState({usuarios:response.data});
        })
        //console.log(this.state.usuarios);
        //console.log("get usuarios");
    }

    postEditarGrupo=async()=>{
        var gruposIds=[];
        this.state.editarGrupo.gruposSeleccionados.forEach((g)=>{
            gruposIds.push(g.id);
        })
        var postEditarGrupos={
            cuentaUsuarioId:this.state.editarGrupo.id,
            gruposIds:gruposIds
        };

        await axios.put(`${process.env.REACT_APP_API}api/UsuarioGrupo/editar`,postEditarGrupos)
        .then(resp=>{
            if(resp.status===200){
                
                //console.log("post editar grupo");
                //console.log(postEditarGrupos);
                this.cerrarModalEditarGrupo();
                this.getUsuariosPorGrupo();
                this.abrirModalInfoGrupoEditado();
                
            }
            else{
                this.abrirModalError();
            }
            

        }).catch(error=>{
            this.abrirModalError();
            //console.log(error.message);
        })
    }

    /*CREAR GRUPO */
    abrirModalCrearGrupo(){
        this.setState({modalCrear:true});
    }

    cerrarModalCrearGrupo(){
        this.setState({modalCrear:false});
        //console.log("cerrar modal CREAR GRUPO"+this.state.modalCrear);
    }

    handlerCrearGrupo=async(e)=>{
        //e.persist();
        await this.setState({
            crearGrupo:{
                ...this.state.crearGrupo,
                [e.target.name]:e.target.value
            }
        })
        //console.log(this.state.crearGrupo);
    }

    postCrearGrupo=async()=>{
       
        var crearGrupo={
            nombre:this.state.crearGrupo.nombre,
        }
        await axios.post(`${process.env.REACT_APP_API}api/Grupo`, crearGrupo)
        .then(resp=>{
            if(resp.status===200){
                this.cerrarModalCrearGrupo();
                this.getGrupos();
                this.abrirModalInfoGrupoCreado();
                //console.log(crearGrupo);
                //console.log("grupo creado");
                
            }else{
                this.abrirModalError();
            }
            
        }).catch(error=>{
            this.setState({modalError:true});
            this.abrirModalError();
        })
    }

    cerrarSesion(){
        this.props.setValue(false);
        Cookies.remove("nombres");
        Cookies.remove("apellidos");
        Cookies.remove("identificacion");
      Cookies.remove("token");
      Cookies.remove("cas");

        Cookies.remove("rol");
        Cookies.remove("username");
        Cookies.remove("DatosPersonalesGIA.CAS");
        Cookies.remove("id");
        Cookies.remove("correoAlterno");
        Cookies.remove("Nombre");
      
      window.location.href = "/logout"
      this.setState({ cerrarSesion: true });
        //console.log("cerrando sesion");
    }

    setearHeader(){
        //console.log("setear header");
        var token = Cookies.get("token")
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        } else {
            axios.defaults.headers.common['Authorization'] = null;
        }
    }

    getDatosBackEnd=async()=>{
        await this.getUsuariosPorGrupo();
        await this.getGrupos();
        this.setState({loading:false})
    }

    componentDidMount(){
        var token = Cookies.get("token");
        var tokendecode = jwt(token);
        this.state.datosUsuario.nombres = tokendecode["Nombres"];
        this.state.datosUsuario.apellidos = tokendecode["Apellidos"];
        this.state.datosUsuario.rol = tokendecode["Rol"];

        if(this.state.datosUsuario.rol != "Admin" ){
            window.location.href = "/inicio"
        }
        this.setState({
            datosUsuario: {
                nombres: tokendecode["Nombres"],
                apellidos: tokendecode["Apellidos"],

            }
        });
        this.setearHeader();
        this.getDatosBackEnd();
    }

    render() {

        var nombresCompletos=`${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`
        var identificacion=this.state.datosUsuario.identificacion;

        return (

            this.state.cerrarSesion? <Navigate to="/Inicio" />:
            this.state.loading ? 
                <ComponenteSpinner></ComponenteSpinner>:
            (<div id="adminGrupos-fondo">
                <HeaderAdmin nombresCompletos={nombresCompletos}></HeaderAdmin>
                <NavBarInfo cerrarSesion={this.cerrarSesion}></NavBarInfo>
                <div className='row adminGrupos-body'>
                    <SideBar nombres={nombresCompletos} cedula={identificacion} tipo={"grupos"}></SideBar>
                    <div className='col-md-9 mt-4'>
                        <p className='adminGrupos-titulo'>Grupos</p>
                        <div className='adminGrupos-container-crearGrupo mt-3'>
                            <span onClick={this.abrirModalCrearGrupo}><FontAwesomeIcon className='adminGrupos-icon' icon={faUsers}></FontAwesomeIcon>
                            <p>Crear nuevo grupo</p>
                            </span>
                            
                        </div>
                        <MaterialTable
                        title=""
                        columns={this.state.columnas}
                        data={this.state.usuarios}
                        actions={this.state.acciones}
                        options={{
                        actionsColumnIndex:-1,
                        headerStyle:{backgroundColor: '#767E9F',color: 'white', fontWeight:'bold', zIndex:0, paddingRight:'45px'}
                        }}
                        localization={{
                            header:{actions:"Acciones"}, 
                            toolbar: {searchPlaceholder: 'Filtrar'},
                            pagination:{labelRowsSelect:"Filas"},
                        }}
                        ></MaterialTable>
                        
                        
                    </div>
                </div>

                {this.state.modalCrear&&
                <ModalAdmin 
                cerrarModal={this.cerrarModalCrearGrupo} 
                tituloHeader="AGREGAR GRUPO" 
                submit={this.postCrearGrupo} 
                txtBtnSubmit={"CREAR"} 
                txtBtnCancel={"CANCELAR"}>
                    <form>
                        <div className="row mt-3">
                            <label className='col-sm-2 col-form-label' htmlFor='nombre' id="modalAdmin-texto">Nombres: </label>
                            <div className="col-sm-8">
                                <input className="form-control" type="text" name="nombre" value={this.state.crearGrupo.nombre} onChange={this.handlerCrearGrupo}></input>
                            </div>
                        </div>
                    </form>
                </ModalAdmin>}

                {this.state.modalEditar&&
                <ModalAdmin 
                cerrarModal={this.cerrarModalEditarGrupo} 
                tituloHeader="EDITAR GRUPO" 
                submit={this.postEditarGrupo} 
                txtBtnSubmit={"EDITAR"} 
                txtBtnCancel={"CANCELAR"}>
                    <p className='text-center'>¿A qué grupo desea cambiar al usuario {this.state.editarGrupo.correo}?</p>
                    
                    <Select 
                    isMulti={true}
                    options={this.state.gruposSelect} 
                    defaultValue={this.state.gruposModalDefault}
                    onChange={this.onChangeMultiSelect}
                    placeholder="Seleccione uno o varios grupos" 
                    isClearable={false}
                    >
                    </Select>
                </ModalAdmin>}


                {this.state.modalGrupoCreado&& 
                <Modal isOpen={this.state.modalGrupoCreado} cerrarModal={this.cerrarModalInfoGrupoCreado} verBoton={true} textoBoton="ACEPTAR" >
                    <p className='text-center'><strong>Grupo creado</strong></p>
                    <div className='mt-6 mb-6'>
                        <img className="registroContra-check" src={check} alt="Exitoso"></img>
                    </div>

                    <p className='text-center'>¡Grupo creado de forma existosa!</p>
                    
                </Modal>}

                {this.state.modalGrupoEditado&& 
                <Modal isOpen={this.state.modalGrupoEditado} cerrarModal={this.cerrarModalInfoGrupoEditado} verBoton={true} textoBoton="ACEPTAR" >
                    <p className='text-center'><strong>Grupo modificado</strong></p>
                    <div className='mt-6 mb-6 text-center'>
                        <img className="registroContra-check" src={check} alt="Exitoso"></img>
                    </div>

                    <p className='text-center'>¡Grupo modificado de forma existosa!</p>
                    
                </Modal>}

                {this.state.modalError&& 
                <Modal isOpen={this.state.modalError} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                    <p className='text-center'><strong>Error en la Solicitud</strong></p>
                    <div className='mt-6 mb-6'>
                        <img className="registroContra-check" src={equis} alt="Error"></img>
                    </div>

                    <p className='text-center'>Ha ocurrido un error durante la solicitud, por favor intente de nuevo.</p>
                    
                </Modal>}
                 
            </div>)
        )
    }
}

export default AdminGrupos
